module.exports = __webpack_public_path__ + "fonts/sourcesansproitalic.df499920.woff2";